import React, {useEffect} from 'react'
import { SIDE_NAV_WIDTH, SIDE_NAV_COLLAPSED_WIDTH, NAV_TYPE_TOP } from 'constants/ThemeConstant';
import { APP_NAME } from 'configs/AppConfig';
import { connect } from "react-redux";
import utils from 'utils';
import { Grid } from 'antd';
import { Link } from 'react-router-dom';

const { useBreakpoint } = Grid;

const getLogoWidthGutter = (props, isMobile) => {
  const { navCollapsed, navType, project } = props;
  const isNavTop = navType === NAV_TYPE_TOP ? true : false
  if(isMobile && !props.mobileLogo) {
    return 0
  }
  if(isNavTop) {
    return 'auto'
  }
  if(navCollapsed) {
    return `${SIDE_NAV_COLLAPSED_WIDTH}px`
  } else {
    return `${SIDE_NAV_WIDTH}px`
  }
}

const getLogo = (props) => {
  const { navCollapsed, logoType, project } = props;
  
  // Para logos en tema claro (light)
  if(logoType === 'light') {
    if(navCollapsed) {
      return '/img/logo-sm-white.png'
    }
    return '/img/logo-white.png'
  }
  
  // Para logos en tema normal
  if (navCollapsed) {
    return '/img/logo-sm-oh.png'
  }
  
  // Obtener el logo desde la configuración del backend
  const projectName = utils.getProjectLocation();
  const allProjects = JSON.parse(localStorage.getItem('allProjects') || '[]');
  const currentProject = allProjects.find(project => project.name === projectName);
  
  // Si existe el logo en la configuración del backend, usarlo; de lo contrario, usar la ruta predeterminada
  return currentProject?.logo_menu || `/img/logos/${projectName}.png`;
}

const getLogoDisplay = (isMobile, mobileLogo, navCollapsed) => {
  if(isMobile && !mobileLogo) {
    return 'd-none'
  } else {
    if(navCollapsed){
      return 'logo-sm'
    }
    else
      return 'logo'
  }
}

export const Logo = (props) => {
  useEffect(() => {
  }, [props.project])
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')
  return (
    <div
      className={getLogoDisplay(isMobile, props.mobileLogo, props.navCollapsed)}
      style={{
        width: `${getLogoWidthGutter(props, isMobile)}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%'
      }}>
      <Link to={utils.getInitRootProject()} aria-label="Ir a inicio" style={{ display: 'inline-flex' }}>
        <img 
          src={getLogo(props)} 
          alt={`${APP_NAME} logo`} 
          onError={(e) => e.target.src = '/img/ohsiris-top.png'} 
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            width: 'auto',
            height: 'auto',
            cursor: 'pointer'
          }}
        />
      </Link>
    </div>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType } =  theme;
  return { navCollapsed, navType }
};

export default connect(mapStateToProps)(Logo);
